import React from 'react';
import { connect } from 'react-redux';
import { fetchUsuarios, setFiltroUsuarios, userTypeIds } from '../../actions/usuariosActions';
import FiltroUsuarios from '../../components/Usuarios/FiltroUsuarios';
import BtnToggleFilter from "../General/Filter/BtnToggleFilter";
import BigSpinner from '../General/BigSpinner';
import UserListItem from './UserListItem';
import ReactPaginate from 'react-paginate';
import { withNavigation } from '../General/withNavigation';
import '../General/AdminListCard.css';

class ListModeradores extends React.Component {
    constructor(props) {
        super(props);
        this.handlePageClick = this.handlePageClick.bind(this);
    }

    componentDidMount() {
        this.buscarUsuarios();
    }

    buscarUsuarios = (isFromFilter = false) => {
        const { idSeller, filtro, currentUserType } = this.props;

        // Force idSeller to 1 if user is Category (Type 1), as they should see users associated with the main Seller (Megatone/1)
        const isCategory = currentUserType == userTypeIds.isCategory;
        const idSellerToSend = isCategory ? 1 : idSeller;

        const nombreUsuario =
            (filtro?.nombreUsuario && String(filtro.nombreUsuario).trim().length >= 3)
                ? String(filtro.nombreUsuario).trim()
                : undefined;

        this.props.fetchUsuarios({
            idSeller: idSellerToSend,
            numeroPagina: filtro?.numeroPagina || 1,
            nombreUsuario,
            activo: filtro?.activo
        });

        if (isFromFilter) {
            this.props.setFiltroUsuarios({ ...filtro, numeroPagina: 1 });
        }
    };

    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;
        const nuevoFiltro = { ...this.props.filtro, numeroPagina: selectedPage };

        const nombre = (nuevoFiltro?.nombreUsuario ?? "").toString().trim();
        if (nombre.length < 3) delete nuevoFiltro.nombreUsuario;
        else nuevoFiltro.nombreUsuario = nombre;

        this.props.setFiltroUsuarios(nuevoFiltro).then(() => this.buscarUsuarios());
    };

    onUsuario = (id) => {
        this.props.navigate(`/Usuarios/Editar/${id}`);
    };

    handleShowFilter = () => {
        const nuevoValor = !(this.props.filtro?.showFilter ?? true);
        this.props.setFiltroUsuarios({
            ...this.props.filtro,
            showFilter: nuevoValor
        });
    };


    goToUserNuevo = (dropdownSelect) => {
        this.props.navigate("/Usuarios/NuevoUser", {
            state: { dropdownSelect }
        });
    };

    handleReset = () => {
        const params = { nombreUsuario: "", numeroPagina: 1, showFilter: true, activo: undefined };
        this.props.setFiltroUsuarios(params).then(() => this.buscarUsuarios(true));
    };

    render() {
        const { userType, userName, usuarios, isLoading, cantidadTotal, filtro } = this.props;

        const tituloToolbar = userType.isAdminMod ? "Crear Moderador" : "Crear Usuario";

        return (
            <div className="container">
                <div className="row align-items-center justify-content-between page-titles admin-page-heading">
                    <div className="col-12 col-md-6 col-lg-5">
                        <h3 className="text-themecolor color-rojo-megatone mb-0">Gestión de usuarios</h3>
                        <p className="small text-body-secondary mb-0 mt-1 d-none d-md-block">
                            Alta, edición y permisos de usuarios del seller{userName ? ` · ${userName}` : ""}.
                        </p>
                    </div>
                    <div className="button-group col-12 col-md-6 col-lg-7 text-md-end mt-2 mt-md-0 d-flex flex-wrap align-items-center justify-content-md-end gap-2">

                        {userType.isAdminMod &&
                            <button
                                type="button"
                                onClick={() => this.goToUserNuevo(2)}
                                className="btn btn-sm btn-green"
                            >
                                <i className="fa fa-plus-circle mx-1" aria-hidden="true" />
                                Crear Proveedor
                            </button>
                        }

                        {(userType.isAdminMod || userType.isSellerAdmin) &&
                            <button
                                type="button"
                                onClick={() => this.goToUserNuevo(0)}
                                className="btn btn-sm btn-green"
                            >
                                <i className="fa fa-plus-circle mx-1" aria-hidden="true" />
                                {tituloToolbar}
                            </button>
                        }

                        <BtnToggleFilter
                            show={this.props.filtro?.showFilter ?? true}
                            handleShow={this.handleShowFilter}
                        />
                    </div>
                </div>

                <div hidden={!(this.props.filtro?.showFilter ?? true)}>
                    <FiltroUsuarios
                        filtro={filtro}
                        fetchUsuarios={() => this.buscarUsuarios(true)}
                        handleReset={this.handleReset}
                    />
                </div>

                {isLoading ? <BigSpinner /> :
                    <div>
                        {usuarios?.length > 0 ? (
                            <>
                                <p className="small text-body-secondary mb-2 mb-md-3">
                                    {cantidadTotal != null && cantidadTotal !== ""
                                        ? `Total: ${cantidadTotal} usuario${Number(cantidadTotal) === 1 ? "" : "s"}`
                                        : `${usuarios.length} resultado${usuarios.length === 1 ? "" : "s"}`}
                                </p>
                                <div className="admin-list-stack">
                                    {usuarios.map((usuario) => (
                                        <UserListItem
                                            key={usuario.idUsuario}
                                            id={usuario.idUsuario}
                                            nombreUsuario={usuario.nombreUsuario}
                                            email={usuario.email}
                                            baja={usuario.baja}
                                            onRowClick={() => this.onUsuario(usuario.idUsuario)}
                                        />
                                    ))}
                                </div>
                            </>
                        ) : (
                            <div
                                className="admin-list-card p-4 p-md-5 text-center text-body-secondary"
                                role="status"
                            >
                                <i className="fas fa-users-slash fa-2x mb-3 d-block opacity-50" aria-hidden="true" />
                                <p className="mb-1 fw-semibold text-body">No se encontraron usuarios</p>
                                <p className="small mb-0">Probá otro criterio de búsqueda o limpiá los filtros.</p>
                            </div>
                        )}
                    </div>
                }

                <div className="d-flex justify-content-center mt-3">
                    <ReactPaginate
                        previousLabel={"Anterior"}
                        nextLabel={"Siguiente"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={Math.ceil((cantidadTotal || 0) / 10)}
                        marginPagesDisplayed={10}
                        pageRangeDisplayed={10}
                        onPageChange={this.handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={Math.max(0, (filtro?.numeroPagina || 1) - 1)}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    isLoading: state.usuarios.isLoading,
    userType: state.general.userType,
    userName: state.general.userName,
    idSeller: state.general.idSeller,
    usuarios: state.usuarios.usuarios,
    filtro: state.usuarios.filtro,
    cantidadTotal: state.usuarios.cantidadTotal,
    cantidadPagina: state.usuarios.cantidadPagina,
    currentUserType: state.general.tipoUsuario
});

export default withNavigation(connect(mapStateToProps, {
    fetchUsuarios,
    setFiltroUsuarios
})(ListModeradores));
